var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClovisCk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44.1mm",
    height: "44.1mm",
    viewBox: "0 0 44.1 44.1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.218 -9.4421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34.414 48.329a16.279 16.837 0 0 1-14.098-8.4185 16.279 16.837 0 0 1 0-16.837 16.279 16.837 0 0 1 14.098-8.4185",
    fill: "none",
    opacity: 1,
    stroke: "#f1f1f1",
    strokeWidth: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.255 10.805a20.013 19.711 0 0 1-20.013 19.711v-19.711z",
    fill: "#ffce1f",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.242 32.468a20.013 19.711 0 0 1 20.013 19.711h-20.013z",
    fill: "#ffce1f",
    opacity: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClovisCk);
export default __webpack_public_path__ + "static/media/clovis_ck.a929758d1ddef9c2cf95b8f4dec35e8d.svg";
export { ForwardRef as ReactComponent };